import { render, staticRenderFns } from "./userbooking.vue?vue&type=template&id=0d8de272&"
import script from "./userbooking.vue?vue&type=script&lang=js&"
export * from "./userbooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports